import { render, staticRenderFns } from "./FilesStep.vue?vue&type=template&id=d8dadf92&scoped=true"
import script from "./FilesStep.vue?vue&type=script&lang=ts"
export * from "./FilesStep.vue?vue&type=script&lang=ts"
import style0 from "./FilesStep.vue?vue&type=style&index=0&id=d8dadf92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8dadf92",
  null
  
)

export default component.exports